import { GET_NDHM_HOST } from "../../constants/env";
import fetch from "../../fetch-client";
import { AxonGenericApiResponse, TABDMFacilityDetails } from "../../types/axon";

export default async function getFacilityDetails({
  hfrId,
}: {
  hfrId: string;
}): Promise<AxonGenericApiResponse<TABDMFacilityDetails>> {
  try {
    const NDHM_HOST = GET_NDHM_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions: RequestInit = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
      mode: "cors",
      credentials: "include",
    };
    const response = await fetch(
      `${NDHM_HOST}/abdm/nhpr/v1/hfr/search/${hfrId}`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
